import React from 'react';
import { View } from 'react-native';
import MyUploadButton from '../../../MyUploadButton';

//= ========================================================================

const UploadButton = ({
  language,
  onFileSelected,
  setMessagePopupState,
  fileLoading,
  setFileLoading,
}) => (
  <View style={{
    width: 109.2,
    height: 33.2,
    margin: '3px 164px 0 0',
    padding: '6px 16px',
    borderRadius: 4,
    border: 'solid 0.6px #CBD5E0',
    marginBottom: 0,
  }}
  >
    <MyUploadButton
      isDisabled={fileLoading.isLoading}
      onFileSelected={(fileName, fileUri, imageId) => {
        onFileSelected(fileName, fileUri, imageId);
      }}
      onFileError={(msg) => {
        setMessagePopupState({
          isMessageVisible: true,
          title: msg,
        });
      }}
      onFileLoading={(isLoading, theName) => {
        setFileLoading({
          isLoading,
          fName: theName,
        });
      }}
      language={language}
    />
  </View>
);

export default UploadButton;
